
import { ref, reactive, inject, onActivated, nextTick, watch } from 'vue';
import { useRoute, useRouter, onBeforeRouteLeave } from 'vue-router';
import { Toast } from "vant";
import { getRuleUrl } from '@/hooks/index'
import Header from "@/components/header/header.vue";
import BottomBtn from "./component/afterBottomBtn.vue";
import KiliButton from "@/components/KiliButton.vue";
import PointList from "@/components/address/address-point-list.vue";
import AfterType from "./component/afterType.vue";
export default {
    name: 'afterSaleExpress',
    components: { Header, PointList, BottomBtn, KiliButton, AfterType },
    setup() {
        let route = useRoute()
        let router = useRouter()
        const $http: any = inject("$http");
        const $store: any = inject("$store");
        let addressData: any = ref([])
        let btnData = reactive([
            {
                plain: true,
                textColor: '#333333',
                bordersColor: '#999999',
                radiusSize: '6px',
                title: 'Cancel',
            },
            {
                textColor: '#E04545',
                bordersColor: '#E04545',
                radiusSize: '6px',
                title: 'Submit',
                loading:false
            },
        ])
        let popupBtnData = reactive([
            {
                plain: true,
                textColor: '#333333',
                bordersColor: '#999999',
                radiusSize: '6px',
                title: 'Cancel',
            },
            {
                textColor: '#E04545',
                bordersColor: '#E04545',
                radiusSize: '6px',
                title: 'Continue',
                loading:false
            },
        ])
        let tipContent:any = ref({
            text:[] as any,
            img:'',
            title:''
        })
        /** 单选弹窗数据 */
        let selectTypeList = ref([{}])
        let pickScoped = ref({
            county: '',
            town: '',
        })
        let expressWay: any = ref({})  // 发货方式
        let logistics:any = ref({
            title: "G4S Express",
            name: "G4S Express",
        }) // 自发货物流方式
        let trackingNo = ref('')
        let sheetTitle = ref('Shipment Method')
        let selectAction = ref('') // 动作面板中选中的单选项值
        let showObj = ref({
            showAction: false,// 是否显示动作面板弹窗
            showDialog: false,// 是否二次确认弹窗
            showCalendar: false,// 是否显示日历面板
            showPicker: false,// 是否显示
        })
        let wayForm = ref()
        /** 选中的自提点 */
        let pickupCheck: any = ref({})
        let pickupUserInfo:any = ref({
            contact_name:'', // 自提点收货/寄货人姓名
            contact_phone:'', // 自提点收货/寄货人电话
            area_code:'', //电话区号
        })
        /** 自提点数据 */
        let pickupData = ref([])
        let pickupTime = ref('') // 上门时间
        let currentType = ref('') // 当前是选择 发货方式/物流方式
        let countyData = ref([]) // 国家/城市数据
        let countyCheck = ref('')// 单选框选中的国家/城市数据 id
        let selectCounty: any = ref({})  // 选中的国家数据
        let selectTown: any = ref({})  // 选中的城市数据
        let detailData: any = reactive({})
        let afterHandleId: any = $store.getAfterId() ? $store.getAfterId():{} // 售后操作相关的id 例如售后id/售后单id
        let skipPath = ref(route.params.isDetail ? `/afterSaleDetails/${afterHandleId.afterId}?name=${route.params.name}`:'/afterSale?name=state_proces')
        let addressMsg = ref('')  // 从地址列表页面带回的地址id/地址信息（为对象）
        let phoneCode = ref('') // 手机号码地区区号
        let addressId = ref('')
        let ruleUrl = ref('')
        let trackRef:any = ref(null)
        let submitParams: any = ref({})
        let existDefaultAddress = ref(false) // 是否存在默认地址，不存在则需要到地址列表进行设置
        // 清除缓存
        sessionStorage.removeItem('isShowCheck');

        if ($store.getAfterWay()) {
            
            expressWay.value = $store.getAfterWay()
        }
        let isCounty = false
        if(common.getStorage('site')){
            phoneCode.value =  common.getStorage('site').telecode
        }
        // 获取详情
        const getAfterSaleDetail = async () => {
            if (!afterHandleId.afterId) {
                router.push('/afterSale')
                return
            }
            getRuleUrl().then((res: any) => {
                const { aftersale_rules }  = res.agreements
                ruleUrl.value = aftersale_rules.display ?   res.agreements.aftersale_rules.url : ''
            })
            const res: any = await $http.getAfterSaleDetail({ id: afterHandleId.afterId })
            if (res.code == 200) {
                detailData = res.data
            }
            if(!expressWay.value.name){
                expressWay.value={
                    name:'3',
                    title:'Send to Kilishop'
                }
                setPickupContact()
            }
            getShowData()
        }
        getAfterSaleDetail()
        const setSelfAddress = () => {
            nextTick(() => {
                let selfAddress = detailData.extra.consignee_info
                if (selfAddress) {
                   let explain = selfAddress.city_name ? `${selfAddress.contact_address}, ${selfAddress.city_name}, ${selfAddress.province_name ? selfAddress.province_name:''}, ${selfAddress.country_name ? selfAddress.country_name:''}`:  selfAddress.contact_address 
                    addressData.value = [{
                        path: '/afterSaleRefund/',
                        leftIcon: 'location',
                        phone: selfAddress.contact_phone,
                        title: selfAddress.contact_name, // 姓名
                        explain: explain,
                        rightIcon: '',
                        ...detailData.consignee_info,
                    }]
                }
            })

        }
        const handleUpdate = (row: any) => {
            pickupCheck.value = row
        }
        const checkedCounty = (item: any, type?: string) => {

            countyCheck.value = item.area_id
            if (isCounty) {
                selectCounty.value = item
                pickScoped.value.county = item.area_name
                pickScoped.value.town = ''
            } else {
                pickScoped.value.town = item.area_name
                selectTown.value = item
                $http.post_stations({ area_id: selectTown.value.area_id }).then((res: any) => {
                    if (res.code === 200) {
                        const pickupDataAll = res.data
                        // 筛选出为kilishop自提点的数据 `business_type` int(11) DEFAULT NULL COMMENT '合作类型：1第三方，2直营，3加盟',
                      const kiliShopData =  pickupDataAll.filter((item:any)=>{
                            return item.dlyp_info&&[2,3].includes(JSON.parse(item.dlyp_info).businessType)
                        })
                        pickupData.value = kiliShopData
                        let transitInfo = type ? null : JSON.parse(route.params.transitInfo as string)
                        // 是否进行反显
                        if (transitInfo) {
                            let newCheck = pickupData.value.filter((item: any) => item.id == transitInfo.info.shipper_info.dlyp_id)
                            pickupCheck.value = newCheck[0]
                        } else {
                            pickupCheck.value = pickupData.value[0]
                        }
                    }
                })
            }
            showObj.value.showPicker = false
        }
        // 去往售后规则页
        const goToRule = () => {
            if(ruleUrl.value){
                window.open(ruleUrl.value)
            }
        }

        //表单校验弹框提示
        const onFailed = (errorInfo: any) => {
            Toast(errorInfo.errors[0].message);
            showObj.value.showDialog = false
        };
        // 根据传入的参数 --设置地址信息 上门地址
        const setAddressData = (address: any) => {
            addressData.value = [{
                path: '/afterSaleRefund/',
                leftIcon: 'location',
                title: `${address.firstname} ${address.lastname}`, // 姓名
                explain: address.area_info ? (address.area_info + ',' + address.address) : ' ' + address.address,
                rightIcon: '',
                ...address,
            }]
        }
        // 操作发货方式/物流方式
        const changeReasonList = (type: any) => {
            currentType.value = type
            if (type === 'expressWay') {
                sheetTitle.value = 'Shipment Method'
                if (expressWay.value) {
                    selectAction.value = expressWay.value.name
                }
                selectTypeList.value = [
                {
                    title: "Send to G4S",
                    name: '1',
                }, 
                {
                    title: "Door-to-door collection",
                    name: '2',
                }, {
                    title: "Send to Kilishop",
                    name: '3',
                },]
            } else {
                if (logistics.value) {
                    selectAction.value = logistics.value.name
                }
                sheetTitle.value = 'Logistics provider'
                selectTypeList.value = [{
                    title: "G4S Express",
                    name: "G4S Express",
                }]
            }
            showObj.value.showAction = true
        }
        // 操作底部按钮
        const handleBtn = (item: any) => {
            if (item.title === "Submit") {
                // 不存在地址则不通过,不能进行 submit 
                if(!addressData.value.length && expressWay.value.name === '2'){
                    // 上门取件必须选地址,否则不能通过
                    Toast('Please select an address')
                }else{
                    wayForm.value.submit()
                    // showObj.value.showDialog = true
                }
                
               
            } else {
                router.back()
            }
        }
        const handlePopupBtn = async (btn:any) => {
            popupBtnData[1].loading = true
            if(btn.title == 'Cancel') {
                popupBtnData[1].loading = false
                return showObj.value.showDialog = false
            }
            const res: any = await $http.setAfterSaleExpressWay(submitParams.value)
            if (res.code === 200) {
                router.push(skipPath.value)
            }
            // showObj.value.showDialog = false
            popupBtnData[1].loading = false
        };

        const closePopup = () => {
            setTipContent(expressWay.value.name)
        }
        // 选中退换货方式
        const handleReasonRadio = (row: any) => {
            selectAction.value = row.name
            if (currentType.value === 'expressWay') {
                addressData.value = []
                expressWay.value = row
            } else {
                logistics.value = row
            }
            showObj.value.showAction = false
        }
        // 获取城市和国家
        const handleCounty = async (type: any) => {
            countyData.value = []
            if (type === 'county') {
                // 请求省份数据
                countyCheck.value = selectCounty.value ? selectCounty.value.area_id : ''
                isCounty = true
                showObj.value.showPicker = true
                getAreas()
            } else {
                // 请求市区数据
                countyCheck.value = selectTown.value ? selectTown.value.area_id : ''
                isCounty = false
                if (selectCounty.value.area_id) {
                    showObj.value.showPicker = true
                    getAreas(selectCounty.value.area_id)
                } else {
                    Toast('Please select a county');
                }
            }

        }
        const getAreas = async (id?: any) => {
            const res: any = await $http.post_areas({
                parent_id: isCounty ? "" : id,
                size: 100,
            })
            if (res.code === 200) {
                countyData.value = res.data
            } else {
                Toast(res.msg)
            }
        }
        // 修改地址
        const editAddress = (isGo?:boolean) => {
            $store.setGoBack('/afterSaleExpress')
            $store.setAfterWay(expressWay.value)
            if(isGo) {
                router.push({
                    path: "/address-list",
                    query: {
                        isShowCheck: 'afterSale'
                    },
                })
                return
            }
            // 如果有地址信息就使用地址信息中的id,没有的话就使用 最开始进入页面时获取的addressId.value
            if((addressData.value[0]&&addressData.value[0].address_id) || addressId.value){
                router.push({
                    path: "/address-list",
                    query: {
                        isShowCheck: addressData.value[0] 
                            && addressData.value[0].address_id 
                            ? addressData.value[0].address_id : addressId.value,
                        isFiltrate: 0 // 是否筛选上门取件 1表示能上门,0表示不能
                    },
                })
            }
        }

        // 操作日历
        const handleCalendar = (date: any) => {
            pickupTime.value = date.toDateString().substr(3).replace(/( )(?!.*\1)/, ',')
            showObj.value.showCalendar = false
        }
        // 获取上门取件的默认数据
        const getDropData = async (id?: string) => {
            const res = await $http.post_address({ action: "select" });
            if (res.code === 200) {
                const data = res.data
                // 是否存在默认地址
               existDefaultAddress.value = data.some((dataItem:any) => dataItem.is_default != 0)
               data.forEach((item: any) => {
                    // 存在id显示id相同的地址数据
                    if (id && item.address_id == id) {
                        setAddressData(item)
                    }
                    
                    // 不存在id则只是将地址(默认地址)id进行存储,便于跳转到选择地址页面
                    if(!id && item.is_default != 0){
                        addressId.value = item.address_id
                    }
                });
            }
        }
        // 提交表单
        const onSubmit = async () => {
            let toastStr = ''
            let params: any = {
                check_id: afterHandleId.checkId,//审核单ID
                check_status: 1,//审核状态1-同意;3-申诉;4-取消  此处发货，所以为同意
                // reason_id: '',//原因ID
                // remark: '',//备注
                info: {
                    // express_sn: '',//物流单号,审核状态check_status=1,transit_type = 1当check_type =5时必须
                    // express_name: '',//物流公司,审核状态check_status=1,,transit_type = 1当check_type =5时必须
                    transit_type: expressWay.value.name,//运输类型;1:自寄;2:上门; 3-自提点,审核状态check_status=1,当check_type =5时必须
                    //发货人信息
                    // shipper_info: {},
                }
            }
            
            if (expressWay.value.name == '1') {
                // 自发货 物流单号和物流公司
                params.info.express_sn = trackingNo.value
                params.info.express_name = logistics.value.name
            } 
            
            if (expressWay.value.name == '2') {
                // 上门取件
                if (addressData.value.length) {
                    params.info.shipper_info = {
                        province_id: addressData.value[0].pronvice_id,//省ID
                        city_id: addressData.value[0].city_id,//城市ID
                        contact_address: addressData.value[0].explain,//地址
                        contact_name: addressData.value[0].title,//收货人姓名
                        contact_phone: addressData.value[0].phone,//收货人手机号
                        address_id: addressData.value[0].address_id,//地址id
                    }
                }
                if(addressData.value[0].dlyp_id > 0 || !addressData.value[0].area_pickup) {
                    toastStr = 'Kindly choose other return methods since rider collection is not available now.'
                }
                params.info.door_time = common.tiemstap(pickupTime.value)
            }

            if(expressWay.value.name === '3'){
                // 自提点
                if(pickupCheck.value?.id){
                    params.info.shipper_info = {
                        province_id: selectCounty.value.area_id,//省ID
                        city_id: selectTown.value.area_id,//城市ID
                        contact_address: pickupCheck.value.address,//地址
                        contact_name: pickupUserInfo.value.contact_name,//收货人姓名
                        contact_phone: pickupUserInfo.value.contact_phone,//收货人手机号
                        area_code: pickupUserInfo.value.area_code, //电话区号
                        dlyp_name:pickupCheck.value.dlyp_name, // 自提点名称
                        dlyp_id: pickupCheck.value.id,//自提点ID
                        address_name: pickupCheck.value.address_name,//自提点地址名称
                        dlpy_mobile: pickupCheck.value.dlyp_mobile,//自提点电话
                    }
                } else {
                    toastStr = 'Please select a KiliShop'
                }
            }
            if(toastStr.length){
                return Toast(toastStr)
            }
            tipContent.value = {
                text: [{
                    value:'1.Kindly ensure you input right info which allows the shipment to be tracked.'
                },{
                    value:'2.Please ensure that product(s) are returned in the original received condition, completed with all the original inclusions, also pack them in original/secure way.'
                },{
                    value:'3. Please includes the Order ID/Contact Number in your parcel to facilitate us identify it once received.'
                }],
                img: '',
                title: 'Notes'
            }
            submitParams.value = params
            // showObj.value.showDialog = true
            handlePopupBtn({})
        }
        onActivated(() => {
            if (route.params?.addressMsg) {
                if (typeof JSON.parse(route.params.addressMsg as string) === 'object') {
                    setAddressData(JSON.parse(route.params.addressMsg as string))
                } else {
                    addressMsg.value = route.params.addressMsg as any
                    getDropData(addressMsg.value)
                }
                return
            }
            getDropData()

        })
        // 根据路由参数判断是否需要进行反显
        const getShowData = () => {
            if (route.params.transitInfo) {
                let transitInfo: any = JSON.parse(route.params.transitInfo as string)
                // selectAction.value = transitInfo.transit_type
                switch (transitInfo.transit_type) {
                    case 1:
                        expressWay.value = {
                            title: "Send to G4S",
                            name: '1',
                        }
                        trackingNo.value=transitInfo.info.express_sn
                        logistics.value.title=transitInfo.info.express_name
                        logistics.value.name=transitInfo.info.express_name
                        break;
                    case 2:
                        expressWay.value = {
                            title: "Door-to-door collection",
                            name: '2',
                        }
                        // addressData.value = [{
                        //     path: '/afterSaleRefund/',
                        //     leftIcon: 'location',
                        //     title: transitInfo.info.shipper_info.contact_name, // 姓名
                        //     explain: transitInfo.info.shipper_info.contact_address,
                        //     phone: transitInfo.info.shipper_info.contact_phone,
                        //     rightIcon: '',
                        //     ...transitInfo.info.shipper_info,
                        // }]
                        getDropData(transitInfo.info.shipper_info.address_id)
                        let date = new Date(transitInfo.info.door_time)
                        pickupTime.value = date.toDateString().substr(3).replace(/( )(?!.*\1)/, ',')
                        // pickupTime.value=transitInfo.info.door_time
                        // checkedCounty(item)
                        break;
                    case 3:
                        expressWay.value = {
                            title: "Send to Kilishop",
                            name: '3',
                        }
                        selectCounty.value = {
                            area_id: transitInfo.info.shipper_info.province_id,
                            area_name: '',
                        }
                        selectTown.value = {
                            area_id: transitInfo.info.shipper_info.city_id,
                            area_name: '',
                        }
                        if (transitInfo.info.shipper_info.province_id) {
                            isCounty = true
                            getAreas().then(() => {
                                let county = countyData.value.filter((item: any) => item.area_id === transitInfo.info.shipper_info.province_id)
                                checkedCounty(county[0])
                                if (transitInfo.info.shipper_info.city_id) {
                                    isCounty = false
                                    getAreas(transitInfo.info.shipper_info.province_id).then(() => {
                                        let town = countyData.value.filter((item: any) => item.area_id === transitInfo.info.shipper_info.city_id)
                                        checkedCounty(town[0])
                                    })
                                }
                            })

                        }
                        break;
                }
            } 
        }
        // 设置自提点联系人方式
        const setPickupContact = ()=>{
            let contact =  detailData.extra.receipt_info 
            pickupUserInfo.value = {
                contact_name:contact.firstname  ? contact.firstname + contact.lastname : contact.true_name,
                contact_phone:contact.phone,
                area_code:contact.area_code
            }
        }
         if(!expressWay.value.name){
            // 当未选择售后方式时,请求上门地址,防止点击select时没有地址id跳转到地址列表不能选择地址
            getDropData()
        }
        const validatorTrack = (val:any) => {
            trackRef.value.focus()
            return /^(G4S)[a-zA-Z\d_]{15}$/.test(val)
        }
        const setTipContent = (newVal:any) => {
            switch (newVal) {
                // 自发货
                case '1':
                    tipContent.value = {
                        text:  [{
                            value: '1.Send the parcel to G4S pickup station and customer bears shipping costs.'
                        },{
                            value:'2.Place the Kilimall order no. and contact details inside the parcel and ship it to the above address.'
                        },{
                            value:'3.Enter the correct 18-character waybill number from the Shipment Waybill as the tracking number and submit.'
                        },{
                            value:'Example:G4SWB4630352099859'
                        }],
                        img:  'https://image.kilimall.com/kenya/aftersale/temp/tmpl20230801.png',
                        title: 'How to return'
                    }
                    setSelfAddress()
                    break;
                // 自提点
                case '3':
                    tipContent.value = {
                        text: [{
                            value: '1. Please send the parcel to the selected Kilishop and confirm the receipt in 7 days.'
                        }, {
                            value: '2. Application will be rejected if valid return was not made in 7 days. You can apply again if still within 15 days after receipt.'
                        }],
                        img: '',
                        title: 'Notes'
                    }
                    setPickupContact()
                    break;
                // 上门
                case '2':
                    tipContent.value = {
                        text: [{
                            value: '1.Rider will pick up your order in with max. 2 times attempt. Please keep your phone on.'
                        }, {
                            value: '2. Application will be rejected if valid return was not made in 7 days. However you can apply again if still within 15days after receipt.'
                        }],
                        img: '',
                        title: 'Notes'
                    }
                    break;
            }
        }
        // 根据发货方式设置相关数据
        watch(() => expressWay.value.name, (newVal: any) => {
            setTipContent(newVal)
        },{immediate:true})
        onBeforeRouteLeave((to: any, from: any) => {
            if (to.path != "/address-list") {
                $store.setAfterWay({})
                $store.setKeepAliveList([])
            } else {
                $store.setKeepAliveList(['afterSaleExpress'])
            }
        })
        return {
            addressData, btnData, popupBtnData, trackRef, tipContent, selectTypeList, pickScoped, expressWay, logistics, trackingNo, sheetTitle, selectAction, showObj, wayForm, pickupCheck,
            pickupData, pickupTime, currentType, countyData, countyCheck, selectCounty, selectTown, skipPath, detailData, phoneCode,pickupUserInfo,existDefaultAddress,
            handleUpdate, checkedCounty, goToRule, onFailed, setAddressData, changeReasonList, handleBtn,handlePopupBtn, handleReasonRadio, handleCounty, getAreas, editAddress, handleCalendar,
            getDropData, onSubmit, validatorTrack,closePopup
        }
    }
}
